// import Vuetify from '@/plugins/Vuetify' // path to Vuetify export

/* ------------------------------------------------------------------------------------------
| Style
'----------------------------------------------------------------------------------------- */
import '@/assets/css/main.scss'
/* ------------------------------------------------------------------------------------------
| Vue resources
'----------------------------------------------------------------------------------------- */
import Vue from 'vue'
import App from '@/layouts/App.vue'
import store from '@/store/index.js'
import router from '@/router/index.js'
import i18n from './i18n'

/* ------------------------------------------------------------------------------------------
| Vue plugins
'----------------------------------------------------------------------------------------- */
import '@/plugins/autoload.js'

// import '@/plugins/idle.js'
/* ------------------------------------------------------------------------------------------
| Vue components
'----------------------------------------------------------------------------------------- */
import '@/components/autoload.js'

// import vuetify from './plugins/Vuetify'
/* ------------------------------------------------------------------------------------------
| Vue app
'----------------------------------------------------------------------------------------- */
Vue.config.productionTip = process.env.NODE_ENV === 'production'
/* ------------------------------------------------------------------------------------------
| Vue Language
// '----------------------------------------------------------------------------------------- */

if (store.state.auth.user) {
  if (store.state.auth.user.language) {
    if (store.state.auth.lang !== store.state.auth.user.language) {
      store.commit('auth/setLang', store.state.auth.user.language)
    } else {
      store.commit('auth/setLang', store.state.auth.user.language)
    }
  } else {
    store.commit('auth/setLang', store.state.auth.lang)
  }
}
// Vue.use(Vuetify)
function initVue () {
  new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}
if (store.state.auth.activeKeycloak === 'SI') {
  try {
    Vue.$keycloak.init({ checkLoginIframe: false }).then(() => {
      initVue()
    }).catch(() => {
      initVue()
    })
  } catch (error) {
    initVue()
  }
} else {
  new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}
